import { ResourceStore } from 'src/stores/ResourceStore/ResourceStore';

export const PaymentFreequencyResourceStore = new ResourceStore(
    'data/paymentFrequency.json',
);
